//dev Version
//const hostname = "http://localhost/bharat-dev/pmd/admin"
//export default hostname;

// Pro Version
  const hostname = "https://printingmachinedeal.com/admin"
  export default hostname;


